import React from 'react'
import { Link } from 'gatsby'
import Logo from 'shared/ui/Logo'
import { useMediaLayout } from 'use-media'
import { Columns, Column } from 'react-flex-columns'
import Heading from 'shared/ui/Heading'
import Icon from 'shared/ui/Icon'
import Centered from 'shared/ui/Centered'
import './PrimaryFooter.scss'

export default function PrimaryFooter() {
  const mediumView = useMediaLayout({ maxWidth: '900px' })

  return (
    <footer>
      <div className="primary-footer-top">
        <Centered>
          <div className="spacing">
            <Columns gutterSize={5} stack={mediumView}>
              <Column flex>
                <div className="spacing">
                  <Logo size={12} />
                  <p className="text-small">
                    ReactTraining.com is the world-renowned React training company who's committed
                    to diversity and education in the tech community.
                  </p>
                  <ul className="list-reset spacing-small">
                    <li>
                      <a
                        href="https://twitter.com/reacttraining"
                        className="icon-text"
                        aria-label="@ReactTraining on Twitter"
                      >
                        <Icon name="twitter" color="black" size={1.3} />
                        <span>ReactTraining</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="mailto:hello@reacttraining.com"
                        className="icon-text"
                        aria-label="Email hello@reacttraining.com"
                      >
                        <Icon name="email" color="black" size={1.3} />
                        <span>hello@reacttraining.com</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </Column>
              <Column size={15}>
                <div className="primary-footer-link-list">
                  <Heading as="h2" size={4}>
                    Company
                  </Heading>
                  <Link to="/">Home</Link>
                  <Link to="/conduct">Workshop Conduct</Link>
                  <Link to="/diversity">Diversity</Link>
                  <Link to="/workshops">Attend a Workshop</Link>
                  <Link to="/corporate-training">Get Corporate Training</Link>
                  <Link to="/learn">Online Courses</Link>
                  <Link to="/team">Our Team</Link>
                  <Link to="/blog">Blog</Link>
                  <Link to="/newsletter">Newsletter</Link>
                </div>
              </Column>
              <Column size={15} className="spacing">
                <div className="primary-footer-link-list">
                  <Heading as="h2" size={4}>
                    Software
                  </Heading>
                  <a href="https://reacttraining.com/react-router">React Router</a>
                  <a href="https://reacttraining.com/reach-ui/">Reach UI</a>
                  <a href="http://remix.run">Remix</a>
                </div>
                <div className="primary-footer-link-list">
                  <Heading as="h2" size={4}>
                    Resources
                  </Heading>
                  <a href="https://reactjs.org/docs">React Docs</a>
                  <a href="https://reactjs.org/docs/hooks-intro.html">React Hooks Docs</a>
                  <a href="https://reactjs.org/docs/hooks-reference.html">Hooks API Reference</a>
                  <a href="https://reactjs.org/docs/hooks-faq.html">Hooks FAQ</a>
                </div>
              </Column>
            </Columns>
          </div>
        </Centered>
      </div>
      <div className="primary-footer-bottom">
        <Centered>
          <Columns split middle>
            <Column>
              <img src="/images/eye-heart-react.svg" alt="I Heart React" className="i♥react" />
            </Column>
            <Column>&copy; {new Date().getFullYear()} ReactTraining.com</Column>
          </Columns>
        </Centered>
      </div>
    </footer>
  )
}
